import classNames from 'helpers/class-names'
import { FC, HTMLAttributes, ReactElement, ReactNode } from 'react'

type CardStackProps = {
  children?: ReactNode
  className?: string
  containerClassName?: string
}

export const CardStack: FC<CardStackProps> = ({
  children,
  className = '',
  containerClassName = '',
}) => {
  return (
    <div className={classNames('px-3 pb-4', className)}>
      <div
        className={classNames(
          'rounded-xl bg-gray-100 dark:bg-gray-800',
          containerClassName,
        )}>
        {children}
      </div>
    </div>
  )
}

export const CardStackDivider = () => {
  return <hr className="my-px border-gray-50 dark:border-gray-700" />
}

type CardStackCardProps = HTMLAttributes<HTMLDivElement> & {
  children?: ReactNode
  cardNotification?: ReactElement
  containerClassName?: string
}

export const CardStackCard: FC<CardStackCardProps> = ({
  children,
  cardNotification,
  className = '',
  containerClassName = '',
  ...props
}) => {
  return (
    <div className={classNames('relative p-3', containerClassName)} {...props}>
      <section
        className={classNames(
          'rounded-lg border border-gray-100 bg-white dark:border-gray-500 dark:bg-gray-600',
          className,
        )}>
        {children}
      </section>
      {cardNotification}
    </div>
  )
}

type CardStackCardBodyProps = HTMLAttributes<HTMLDivElement> & {
  children?: ReactNode
}
export const CardStackCardBody: FC<CardStackCardBodyProps> = ({
  children,
  className = '',
}) => {
  return (
    <div
      className={classNames(
        'flex items-start pb-4 pl-4 pr-3.5 pt-4',
        className,
      )}>
      {children}
    </div>
  )
}

type CardStackCardFooterProps = HTMLAttributes<HTMLDivElement> & {
  children?: ReactNode
}
export const CardStackCardFooter: FC<CardStackCardFooterProps> = ({
  children,
  className = '',
}) => {
  return (
    <div
      className={classNames(
        'rounded-b-lg border-t border-gray-100 bg-gray-50 px-3 pb-2 pt-2 dark:border-gray-500 dark:bg-gray-600',
        className,
      )}>
      {children}
    </div>
  )
}
